export const AppConfig = {
  apiBaseUrl: 'https://cas-api.linku-test4.nl',
  oneSignalAppId: '5ba58575-92aa-4051-aba5-c82643940825',
  googleSenderId: '102720521078'
};


// WEBPACK FOOTER //
// ./src/config/config.staging.ts